import { Iuser } from './../Interface/Iuser';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  user: Iuser = {
    userId: -1,
    username: '',
    password: '',
    isSale: false,
    authorizationKey: '',
    IsSaleAdmin: false
  };
  _userID: BehaviorSubject<Iuser> = new BehaviorSubject<Iuser>(this.user);
  userID$: Observable<Iuser> = this._userID.asObservable();

  setToken(w: any) {
    if (w) {
      w.userId = w.userId ?? w.UserId ?? -1;
      w.username = w.username ?? w.Username ?? w.UserName ?? '';
      w.authorizationKey = w.authorizationKey ?? w.AuthorizationKey ?? '';
      w.isSale = w.isSale ?? w.IsSale ?? false;
      w.IsSaleAdmin = w.IsSaleAdmin ?? w.isSaleAdmin ?? false;
    }
    localStorage.setItem('VIVIANCRMUser', JSON.stringify(w));
    this._userID.next(w);
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('VIVIANCRMUser');
    var emptyUser: Iuser = {
      userId: -1,
      username: '',
      password: '',
      isSale: false,
      authorizationKey: '',
      IsSaleAdmin: false
    };
    this._userID.next(emptyUser);
  }

  async getUserAsPromise(): Promise<Iuser> {
    return this.userID$.toPromise();
  }

  constructor() {
    let data: string = localStorage.getItem('VIVIANCRMUser') || '{}';
    let userObj: any = {};
    if (data !== '{}') {
      try {
        userObj = JSON.parse(data);
        userObj.userId = userObj.userId ?? userObj.UserId ?? -1;
        userObj.username = userObj.username ?? userObj.Username ?? userObj.UserName ?? '';
        userObj.authorizationKey = userObj.authorizationKey ?? userObj.AuthorizationKey ?? '';
        userObj.isSale = userObj.isSale ?? userObj.IsSale ?? false;
        userObj.IsSaleAdmin = userObj.IsSaleAdmin ?? userObj.isSaleAdmin ?? false;
      } catch {
        userObj = this.user;
      }
    } else {
      userObj = this.user;
    }
    this._userID = new BehaviorSubject<Iuser>(userObj);
    this.userID$ = this._userID.asObservable();
  }
}
